import { WorldWordmark } from "./WorldPrimitives";

export function ReceiverBackdrop() {
  return <div className="tgc-receiver-backdrop" aria-hidden="true" />;
}

export function ReceiverHeader({ eyebrow, action }) {
  return (
    <header className="tgc-receiver-header">
      <div>
        <WorldWordmark className="tgc-receiver-wordmark" />
        {eyebrow && <p className="tgc-receiver-eyebrow">{eyebrow}</p>}
      </div>
      {action}
    </header>
  );
}

export function ReceiverStatusSurface({ heading, body, kind = "neutral", action }) {
  return (
    <main className="tgc-receiver-shell tgc-receiver-shell--status">
      <ReceiverBackdrop />
      <ReceiverHeader eyebrow="A gift for you" />
      <section className={`tgc-receiver-status tgc-receiver-status--${kind}`} aria-labelledby="receiver-status-heading">
        <span className="tgc-receiver-status__mark" aria-hidden="true" />
        <h1 id="receiver-status-heading">{heading}</h1>
        {body && <p>{body}</p>}
        {action}
      </section>
    </main>
  );
}
